import React, { useState, useRef, useEffect , useMemo, useCallback} from "react";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSignOutAlt } from '@fortawesome/free-solid-svg-icons'
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import InputGroup from 'react-bootstrap/InputGroup';
import customFetch from './customFetch';

let LAT = null;
let LON = null;
let TOKEN = null;
let COMPANIES_GET = false;
let IS_ADMIN = null;
let IS_SYSTEM = null;
let POSSIBLE_ADDRESSES = {};
let CLOSEST_PRO_COMPANY = null;

function getDistance(lat0, lon0, lat1, lon1) {
  const R = 6371e3;
  const Phi0 = (lat0 * Math.PI) / 180;
  const Phi1 = (lat1 * Math.PI) / 180;
  const dPhi = ((lat1 - lat0) * Math.PI) / 180;
  const dL = ((lon1 - lon0) * Math.PI) / 180;
  const a =
    Math.sin(dPhi / 2) * Math.sin(dPhi / 2) +
    Math.cos(Phi0) *
      Math.cos(Phi1) *
      Math.sin(dL / 2) *
      Math.sin(dL / 2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  const ans = R * c;
  return ans;
}

const Home = (props) => {
    
    const navigate = useNavigate();
    const [login, setLogin] = useState(false);
    const [coordinates, setCoordinates] = useState("Определение...");
    const [city, setCity] = useState("");
    const [company, setCompany] = useState("");
    const [shopAddress, setShopAddress] = useState("");

    const [addressesCitiesArray, setAddressesCitiesArray] = useState([]);
    const [selectedValue, setSelectedValue] = useState('');

    // if (true || login === "admin" || login === "superadmin") {
    //     navigate("/admin");
    // }

    async function changeShop(lat,lon) {
      if (lat === null || lon === null) return;

      let ar = await customFetch("/api/companies?lat="+lat+'&lon='+lon, {
        method: "GET",
        headers: {'authorization': TOKEN}
      })

      ar = await ar.json();
      
      ar.sort((a, b) => {
        return getDistance(a.coordinates[0],a.coordinates[1],lat,lon) - getDistance(b.coordinates[0],b.coordinates[1],lat,lon)
      }); 
      
      setCoordinates(lat+", "+lon)
      if (ar.length > 0) {
        const closest = ar[0];

        if (CLOSEST_PRO_COMPANY === null) {
          CLOSEST_PRO_COMPANY = closest.pro_company;
        }

        localStorage.setItem("coordinates", lat+", "+lon)
        localStorage.setItem("coordinates_faked", closest.pro_company != CLOSEST_PRO_COMPANY)
        localStorage.setItem("address_human", closest.city+', '+closest.address)
        localStorage.setItem("shop_human", closest.company)
        setCity(closest.city)
        setCompany(closest.company)
        setShopAddress(closest.address)
        setSelectedValue(closest.pro_company)
        if (COMPANIES_GET) {
          return;
        }

        const selectValues = [];
        for (const i of ar) {
          POSSIBLE_ADDRESSES[i.pro_company] = i;
          selectValues.push(
            {
              value: i.pro_company,
              label: i.company,
            }
          )
        }

        setAddressesCitiesArray(selectValues);
        COMPANIES_GET = true;
        
        
      }
      return;
    }

    useEffect(() => {

      let user = null;
        try {
             user = JSON.parse(localStorage.getItem("user"))
             TOKEN = user.token;
             const payload = JSON.parse(atob(user.token.split('.')[1]));
             IS_ADMIN = payload.is_admin;
             IS_SYSTEM = payload.is_system;
             console.log()
        } catch (e) {
            localStorage.removeItem("user")
        }
        if (!user || !user.token) {
          navigate("/login")
          return;
        }
        (async() => {
          localStorage.removeItem("coordinates_faked");
          localStorage.removeItem("coordinates");
          let r = await customFetch("/api/verify", {method: "GET",headers: {'authorization': TOKEN}})
          if (r.status === 200) {
            setLogin(user.login)
          } else {
            localStorage.removeItem("user")
            navigate("/login")
          }
          if (IS_ADMIN || IS_SYSTEM) {
            navigate("/admin")
            return;
          }

          async function geoSuccess(arr) {
            LAT = arr.coords.latitude;
            LON = arr.coords.longitude;
            await changeShop(LAT, LON);
          }

          function geoError() {
            if (window.location.hostname == 'localhost') {
              //LAT = 51.175122
              //LON = 71.423701

              LAT = 55.175122
              LON = 61.423701

              changeShop(LAT, LON);
              return;
            }
            setCoordinates("произошла ошибка")
            alert("Не удалось определить координаты, фотографии делать нельзя")
            window.navigation.reload();
          }


          const options = {
            enableHighAccuracy: true,
            timeout: 15000,
            maximumAge: 60000,
          };
          navigator.geolocation.getCurrentPosition(geoSuccess,geoError,options);

        }) ()
      }, [])


    return (
        (
            login ?     <div className="mainContainer">
            <header style={{
                height: '6vh', 
                width: '100%', 
                top: 0,
                backgroundColor: '#8540f5', 
                position: 'absolute',
                display: 'flex', 
                justifyContent: 'space-between',
                alignItems: 'center',
                paddingRight: '1%',
                paddingLeft: '1%'
                }}>
                <img src="proanalytics.svg" style={{height:'85%'}} alt=""></img>
                <FontAwesomeIcon icon={faSignOutAlt} style={{height: '75%'}} color="white" onClick={() => {
                    localStorage.removeItem("user")
                    navigate("/login")
                }}/> 
            </header> 
            <div>
                <div style={{color: 'grey'}}>
                <p>UserID: {login}</p>
                <p>Координаты: {coordinates}</p>
                <p>Город: {city}</p>
                <p>Компания: {company}</p>
                <p>Адрес: {shopAddress}</p>
                </div>
                <InputGroup className="mb-3">

                <Form.Select
                value={selectedValue}
                onChange={(a,b,c) => {
                  if (!a.isTrusted) return;
                  const newShop = POSSIBLE_ADDRESSES[a.target.value]
                  changeShop(newShop.coordinates[0],newShop.coordinates[1]);
                }} aria-label="Default select example">
                {addressesCitiesArray.map((option) => (
                      <option key={option.value} value={option.value}>
                        {option.label}
                      </option>
                    ))}
                    
                </Form.Select>

                </InputGroup>
                <Button style={{width: '100%', margin: 5}} as="a" href="/camera/index.html" size="lg" variant="outline-primary">Сделать фото</Button>
                <Button style={{width: '100%', margin: 5}}  as="a" href="/user" size="lg" variant="outline-secondary">Статистика</Button>
            </div> 
    </div> : ''
        )

    );
}

export default Home